var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.895 6.5035C14.8944 6.38219 14.8693 6.26226 14.8212 6.1509C14.773 6.03954 14.7029 5.93906 14.615 5.8555L9.47998 0.722498C9.27798 0.527498 9.06798 0.441498 8.84798 0.441498C8.34798 0.441498 7.98898 0.792498 7.98898 1.2695C7.98898 1.5195 8.09098 1.7295 8.24698 1.8865L10.005 3.6675L12.27 5.7375L10.458 5.6285H0.987981C0.464981 5.6285 0.10498 5.9885 0.10498 6.5035C0.10498 7.0115 0.464981 7.3705 0.987981 7.3705H10.457L12.269 7.2615L10.004 9.3315L8.24598 11.1135C8.16395 11.1939 8.09886 11.2899 8.05455 11.3959C8.01024 11.5019 7.9876 11.6156 7.98798 11.7305C7.98798 12.2065 8.34798 12.5585 8.84798 12.5585C9.08073 12.5549 9.30259 12.4593 9.46498 12.2925L14.613 7.1445C14.7003 7.06209 14.7702 6.96297 14.8185 6.85303C14.8667 6.74309 14.8924 6.62456 14.894 6.5045L14.895 6.5035Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.c0ea6d6baf4703b36d8db12b9008d00c.svg";
export { ForwardRef as ReactComponent };